import { addAuthInterceptors } from '@dentalux/security'

import axios from 'axios'

const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
})

const httpWithCredentials = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
})

// @ts-expect-error type mismatch with addAuthInterceptors
addAuthInterceptors(httpWithCredentials)

export type SignedDocumentResult = {
  documentReferenceId: string
  patientReferenceId: string
  clinicReferenceId: string
  step: string
  documentKey: string | null
  signed: boolean
  valid: boolean
  expired: boolean
  languageCode: string | null
  createdAt: string | null
}

type CodeSecuredInput = {
  patientReferenceId: string
  step: string
  code: string
  language: string
}

const publicDocumentPath = (patientReferenceId: string, step: string): string =>
  `/public/patients/${patientReferenceId}/signed-documents/${step}`

export const getSignedDocumentDownloadUrl = ({
  patientReferenceId,
  step,
  code,
  language,
}: CodeSecuredInput): string => {
  const base = `${process.env.REACT_APP_API_URL}${publicDocumentPath(patientReferenceId, step)}/download`
  const query = `code=${encodeURIComponent(code)}&language=${encodeURIComponent(language)}`

  return `${base}?${query}`
}

export const getSignedDocument = async ({
  patientReferenceId,
  step,
  code,
  language,
}: CodeSecuredInput): Promise<SignedDocumentResult> => {
  const { data } = await http.get(publicDocumentPath(patientReferenceId, step), {
    params: { code, language },
  })

  return data
}

export type SignSignedDocumentInput = CodeSecuredInput & {
  signatureEncoded: string
}

export const signSignedDocument = async ({
  patientReferenceId,
  step,
  ...body
}: SignSignedDocumentInput): Promise<SignedDocumentResult> => {
  const { data } = await http.post(`${publicDocumentPath(patientReferenceId, step)}/sign`, body)

  return data
}

export type UpdateSignedDocumentInput = {
  documentReferenceId: string
  valid: boolean
}

export const updateSignedDocumentValidity = async ({
  documentReferenceId,
  valid,
}: UpdateSignedDocumentInput): Promise<SignedDocumentResult> => {
  const { data } = await httpWithCredentials.patch(`/signed-documents/${documentReferenceId}`, { valid })

  return data
}
